
(function() {
  if (window.innerWidth > 749) return;
  function init() {
    document.querySelectorAll('.carousel').forEach(function(carousel) {
      var scroller = carousel.querySelector('[class*="grid"], ul[role="list"]');
      if (!scroller || !scroller.children.length) return;
      if (scroller.dataset.autoplay) return;
      scroller.dataset.autoplay = 'true';
      var idx = 0;
      var total = scroller.children.length;
      setInterval(function() {
        idx++;
        if (idx >= total) {
          idx = 0;
          scroller.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          var card = scroller.children[idx];
          scroller.scrollTo({ left: card.offsetLeft - 12, behavior: 'smooth' });
        }
      }, 3000);
    });
  }
  setTimeout(init, 2000);
})();
